import BreadCrumb from "Common/BreadCrumb";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useQuestionPerSet } from "./useTrivia";
import QuestionBox from "./QuestionBox";

const QuestionsPerSet = () => {
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState<any>([]);
  const { isLoading, questionsPerSet } = useQuestionPerSet(id);

  useEffect(() => {
    if (questionsPerSet) {
      setData(questionsPerSet);
    }
  }, [questionsPerSet]);


  return (
    <React.Fragment>
      <BreadCrumb title="Questions Per Set" pageTitle="Questions Set" />

      {isLoading && <p>Loading...</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {data?.questions?.map((question, index) => (
          <QuestionBox
            key={index}
            questionText={question.questionText}
            choices={question.choices}
            correctAnswers={question.correctAnswers}
          />
        ))}
      </div>
    </React.Fragment>
  );
};

export default QuestionsPerSet;
